import React, { Component } from "react"
// import measureElement from "../utils/js/measureElement";

// eslint-disable-line no-unused-vars
import SvgPlus from "../_svgs/mini/Plus"
import { isBrowser } from "react-device-detect"
import qs from "query-string"

import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"
import * as trackingHelper from "../../helpers/tracking"

import "./_tag-list.scss"

class TagList extends Component {
  static defaultProps = {
    modifier: "",
    tags: [
      { label: "Dagcreme", amount: 12, url: "#" },
      { label: "Natcreme", amount: 2, url: "#" },
      { label: "Øjenpleje", amount: 465, url: "#" },
      { label: "Gaveæsker", amount: 20, url: "#" },
      { label: "Ansigtsmasker", amount: 1, url: "#" },
      { label: "Consectetur", amount: 1, url: "#" },
      { label: "Lorem", amount: 1, url: "#" },
      { label: "Ipsum", amount: 1, url: "#" },
      { label: "Dolor", amount: 1, url: "#" },
      { label: "Sit", amount: 1, url: "#" },
      { label: "Amet", amount: 1, url: "#" },
      { label: "Adipiscing", amount: 1, url: "#" },
      { label: "Elit", amount: 1, url: "#" },
      { label: "QUam", amount: 1, url: "#" },
    ],
    headline: {},
    description: {},
    defaultHeadlineText: "this is the headline",
    defaultDescriptionText: "this is the description",
    expandLabelText: "se flere",
  }

  constructor(props) {
    super(props)

    this.tagListRef = React.createRef()

    let isTablet = window.innerWidth > 750 && window.innerWidth < 950

    let queryString = qs.parse(window.location.search)

    const selectedTaxonomies = Array.isArray(queryString["t"]) ? queryString["t"] : queryString["t"] ? [queryString["t"]] : []

    const selectedValues = this.props.tags.filter((tag) => selectedTaxonomies.find((tax) => tag.taxonomyFilter === tax))

    this.state = {
      tagMaxHeight: isTablet ? 80 : isBrowser ? 40 : 108,
      measuredHeight: 0,
      expanded: false,
      tags: this.props.tags || [],
      tagsShown: [],
      tagsHidden: [...this.props.tags],
      iterations: 0,
      ready: false,
      selectedValues,
      activeTaxonomies: [],
    }

    //Tablet: 80 | 2 x (30h+5m+5m)
    //Desktop: 40 | 1 x (30h+5m+5m)
    //Mobile: 108 | 3 x (30h+3m+3m)

    //console.log("tagMaxHeight:"+this.state.tagMaxHeight)
  }

  expandAllHandler = () => {
    this.setState({ expanded: true, ready: true })
    this.setState({ tagsShown: this.state.tagsShown.concat(this.state.tagsHidden), tagsHidden: [] })
  }

  handleEvent(event) {
    const { type } = event
    switch (type) {
      case emits.SEARCH_FACETS_UPDATED:
        console.debug(emits.SEARCH_FACETS_UPDATED, event.facets)
        this.setTagsAndTaxonomyData(event.facets)
        break
      default:
      // ignore
    }
  }

  componentDidMount() {
    Emitter.on("*", (event) => this.handleEvent(event))
    this.injectTagRecursive()
  }

  setTagsAndTaxonomyData(facets) {
    const taxonomyFacet = facets && facets.find((f) => f.id === "AllTaxonomies_ss")
    if (taxonomyFacet) {
      const { tags } = this.state
      const selectedTaxonomies = taxonomyFacet.data.filter((tax) => tax.checked)
      tags.map((tag) => {
        const tagFilter = tag.taxonomyFilter.split("*")[0]
        const selectedTag = selectedTaxonomies.find((sTax) => sTax.filter.endsWith(tagFilter))
        tag.checked = !!selectedTag
        return tag
      })
      const selectedValues = tags.filter((tag) => tag.checked)
      this.setState({ tags, activeTaxonomies: taxonomyFacet.data, selectedValues })
    } else {
      this.setState({ activeTaxonomies: [] })
    }
  }

  injectTagRecursive = () => {
    // let measuredHeight = measureElement(this.refs['tag-list']).height,
    // let measuredHeight = document.querySelector('.tag-list').clientHeight,

    let measuredHeight = this.tagListRef.current.clientHeight,
      tagsShown = this.state.tagsShown,
      tagsHidden = this.state.tagsHidden,
      nextTag = tagsHidden[0]

    if (this.state.iterations > 100) {
      // INFINITE LOOP FAILSAFE
      return false
    }

    //console.log(measuredHeight + " > "+this.state.tagMaxHeight+" ?")
    if (!nextTag) {
      this.setState({ expanded: true, ready: true })
      // console.log("...all tags shown!")
    } else if (measuredHeight <= this.state.tagMaxHeight) {
      tagsShown.push(nextTag)
      tagsHidden.shift()
      //console.log("...still room...")
      // console.log("tagsShown"+tagsShown);
      // console.log("tagsHidden"+tagsHidden);

      this.setState({ tagsShown: tagsShown, tagsHidden: tagsHidden }, () => {
        this.injectTagRecursive()
      })
      // this.setState({tagsHidden:tagsHidden});

      //console.table(this.state.tagsShown.length);
    } else {
      tagsHidden.unshift(tagsShown.pop())
      this.setState({ tagsShown: tagsShown, tagsHidden: tagsHidden })
      this.setState({ ready: true })

      //console.log("...no more!")
    }
    this.setState({ iterations: this.state.iterations + 1 })
  }

  onTagChange = (event) => {
    const checkbox = event.target
    let { selectedValues } = this.state
    const currentTag = this.state.tags.find((t) => t.label === checkbox.name)
    let queryString = qs.parse(window.location.search)
    let taxonomies = queryString["t"] || []
    if (!Array.isArray(taxonomies)) taxonomies = [taxonomies]

    if (checkbox.checked) {
      selectedValues.push(currentTag)
      taxonomies.push(currentTag.taxonomyFilter)
      queryString["t"] = taxonomies
      if (selectedValues.length === 1) {
        // single selection
        window.history.replaceState({}, currentTag.label, currentTag.url + "?" + qs.stringify(queryString))
        this.props.headline.innerText = currentTag.label
        this.props.description.innerText = currentTag.description || ""
      } else {
        // multiple selections
        // selectedValues.map(v => taxonomies.push(v.taxonomyFilter))
        // queryString["f"] = taxonomies
        window.history.replaceState({}, this.props.defaultHeadlineText, this.props.defaultUrl + "?" + qs.stringify(queryString))
        this.props.headline.innerText = this.props.defaultHeadlineText
        this.props.description.innerText = this.props.defaultDescriptionText || ""
      }
      Emitter.emit("*", {
        type: emits.SEARCH_FILTER_ACTIVATED,
        filter: currentTag,
      })
    } else {
      selectedValues = selectedValues.filter((s) => s.label !== currentTag.label)
      taxonomies = taxonomies.filter((f) => f !== currentTag.taxonomyFilter)
      queryString["t"] = taxonomies
      if (selectedValues.length === 0) {
        // no selections
        window.history.replaceState({}, this.props.defaultHeadlineText, this.props.defaultUrl + "?" + qs.stringify(queryString))
        this.props.headline.innerText = this.props.defaultHeadlineText
        this.props.description.innerText = this.props.defaultDescriptionText || ""
        // TODO clear taxonomies
      } else if (selectedValues.length > 1) {
        window.history.replaceState({}, this.props.defaultHeadlineText, this.props.defaultUrl + "?" + qs.stringify(queryString))
        // still multiple
        // no history change
        // window.history.replaceState({},this.props.defaultHeadlineText,this.props.defaultUrl)
      } else {
        // down to exactly one find the selected one
        const singleTag = selectedValues[0]
        window.history.replaceState({}, singleTag.label, singleTag.url + "?" + qs.stringify(queryString))
        this.props.headline.innerText = singleTag.label
        this.props.description.innerText = singleTag.description || ""
      }
      Emitter.emit("*", {
        type: emits.SEARCH_FILTER_DEACTIVATED,
        filter: currentTag,
      })
      console.debug("unselected:", currentTag)
    }

    this.setState({ selectedValues })
  }

  async trackClick(filterTag) {
    await trackingHelper.trackFilterClick(filterTag, "filter products - tag")
  }

  render() {
    return (
      <div className={`tag-list ${this.state.ready ? "is-ready" : ""}`} ref={this.tagListRef} data-responsive>
        {this.state.tagsShown &&
          this.state.tagsShown.map((item, index) => {
            const { activeTaxonomies, selectedValues } = this.state
            const isSelected = selectedValues.find((t) => t.taxonomyFilter === item.taxonomyFilter)
            const activeTax = activeTaxonomies.find((at) => at.title + "*" === item.taxonomyFilter)
            const count = activeTax && activeTax.count
            return (
              <div className="tag" key={index}>
                <input
                  name={item.label}
                  id={`tag-${index}`}
                  type="checkbox"
                  onClick={() => this.trackClick(item.label)}
                  key={index}
                  onChange={this.onTagChange}
                  defaultChecked={isSelected}
                  value={isSelected}
                />
                <label className="tag__text" htmlFor={`tag-${index}`}>
                  {item.label} ({count || 0})
                </label>
              </div>
            )
          })}
        {!this.state.expanded && (
          <button className="tag" onClick={this.expandAllHandler}>
            <span className="tag__text">
              <span>{this.props.expandLabelText}</span> <SvgPlus />
            </span>
          </button>
        )}
      </div>
    )
  }
}

export default TagList
